import { render, staticRenderFns } from "./SkillMatrixReviewConf.vue?vue&type=template&id=77b1f454"
import script from "./SkillMatrixReviewConf.vue?vue&type=script&lang=js"
export * from "./SkillMatrixReviewConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports